import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
const RugTabs = ({ activeTabs, selectTabs, stepOnboarding, texts }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div className="text-center rug-tab-div relative">
      <button
        style={{ zIndex: stepOnboarding === 1 ? 1 : 0 }}
        className={activeTabs === "market_rug" ? "rug-tab-active" : ""}
        onClick={() => selectTabs("market_rug")}
      >
        {texts?.market_carpet}
      </button>
      <button
        style={{ zIndex: stepOnboarding === 1 ? 1 : 0 }}
        className={activeTabs === "your_rug" ? "rug-tab-active" : ""}
        onClick={() => selectTabs("your_rug")}
      >
        {texts?.your_own_carpet}
      </button>
      <button
        className={activeTabs === "your_pic" ? "rug-tab-active" : ""}
        onClick={() => selectTabs("your_pic")}
      >
        {texts?.your_photo}
      </button>
      <div
        style={{
          position: "absolute",
          display: stepOnboarding == 1 ? "block" : "none",
          top: isMobile ? 40 : 70,
          zIndex: 1,
        }}
      >
        <p style={{ color: "#fff", fontSize: isMobile ? 16 : 24 }}>
          ابتدا یکی از گزینه های مقابل را انتخاب کنید
        </p>
      </div>
    </div>
  );
};

export default RugTabs;
